// extracted by mini-css-extract-plugin
export var headingWrapper = "index-module--heading-wrapper--4GP9J";
export var main = "index-module--main--rJ5vK";
export var nav = "index-module--nav--yYO+H";